module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/bnr_resort_fair_banner_pc-89b67b65da5ae4a201068c8ab241c527.jpg";